import { customElement } from 'lit/decorators.js';
import OutlineTabPanel from 'src/components/base/outline-tabs/outline-tab-panel/outline-tab-panel';

/**
 * The IdbTabPanel component
 * @element idb-tab-panel
 */
@customElement('idb-tab-panel')
export class IdbTabPanel extends OutlineTabPanel {}
